<script setup>
import { ref, computed } from 'vue'
import PageViewAbout from '@/components/temp/PageViewAbout.vue'
import LangTransition from '@/components/temp/LangTransition.vue'

console.log('[About] setup ....')
</script>

<template>
  <main>
    <PageViewAbout />
    <br />
    <LangTransition />
  </main>
</template>

<style scoped></style>
